<template>
    <div class="loading fill-height" v-if="loading">
        <v-container class="fill-height" fluid>
          <v-row justify="center" align-content="center" align="center" class="fill-height">
                <v-col  style="text-align:center;">
                  <p class="loading_text" :v-if="authLoading">Please wait for authentication...</p>
                  <v-progress-circular :size="35" :width="3" color="grey" indeterminate >
                  </v-progress-circular>
                </v-col>
            </v-row>
        </v-container>

         <v-snackbar
            v-model="errorLoading"
            color="info"
            :timeout="0"
            :top="true"
          >
            {{ errorMsg }}
            <v-btn
              dark
              text
              @click="errorLoading = false"
            >
              Close
            </v-btn>
          </v-snackbar>

    </div>

</template>
<script>
export default {
 data() {
    return {
      loading: true,
      authLoading: true,
      createProfileLoading: false,
      errorMsg: '',
      errorLoading: false,
      oauthParams : {},
      returnUrl: null
    }
  },
  async created() {
      this.readQueryParam();
      this.storeUserInfo();
      //this.startMMS();
  },
  methods : {
      readQueryParam(){
         let { data } = this.$route.query;
         try {
           if(data)
            this.oauthParams = JSON.parse(data);
           this.returnUrl = this.$store.getters.returnUrl;
         } catch (error) {
           this.errorMsg = "Account data is not valid";
           this.errorLoading = true;
         }

      },
      storeUserInfo(){
        if(this.oauthParams.errMsg == 'OK'){
          this.$store.dispatch('login',this.oauthParams.userInfo);
        }

        this.$store.dispatch('clearReturnUrl');
        this.$router.push(this.returnUrl || 'home');
      },
      resultHandle(res){
          let result;
          if(typeof res == 'object')
              result = res;
          else
              result = res[0];
          if(Array.isArray(result))
                result = result[0];

          if(result.Reply)
            return result.Reply;
          else if(result.Reply == '')
            return {};
          else
            return result;
      },

  }
}
</script>
<style scoped>
 .loading{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left:0;
  z-index: 50;
  background-color: rgba(255, 255, 255, 0.4196078431372549);
}
.loading_text{
      font-weight: bold;
    color: #000;
    font-size: 11pt;
}
</style>
